const langMenuOptions = [
  {
    label: "C",
    value: "c",
    lang: "clike",
    versionIndex: "4"
  },
  {
    label: "C++",
    value: "cpp",
    lang: "clike",
    versionIndex: "4"
  },
  {
    label: "C++ 14",
    value: "cpp14",
    lang: "clike",
    versionIndex: "3"
  },
  {
    label: "C++ 17",
    value: "cpp17",
    lang: "clike",
    versionIndex: "0"
  },
  {
    label: "Clojure",
    value: "clojure",
    lang: "clojure",
    versionIndex: "2"
  },
  {
    label: "C#",
    value: "csharp",
    lang: "clike",
    versionIndex: "3"
  },
  {
    label: "Go",
    value: "go",
    lang: "go",
    versionIndex: "3"
  },
  {
    label: "Haskell",
    value: "haskell",
    lang: "haskell",
    versionIndex: "3"
  },
  {
    label: "Java",
    value: "java",
    lang: "clike",
    versionIndex: "3"
  },
  {
    label: "NodeJS",
    value: "nodejs",
    lang: "javascript",
    versionIndex: "3"
  },
  {
    label: "Objective C",
    value: "objc",
    lang: "clike",
    versionIndex: "3"
  },
  {
    label: "Pascal",
    value: "pascal",
    lang: "pascal",
    versionIndex: "2"
  },
  {
    label: "Perl",
    value: "perl",
    lang: "perl",
    versionIndex: "3"
  },
  {
    label: "PHP",
    value: "php",
    lang: "php",
    versionIndex: "3"
  },
  {
    label: "Python 2",
    value: "python2",
    lang: "python",
    versionIndex: "2"
  },
  {
    label: "Python 3",
    value: "python3",
    lang: "python",
    versionIndex: "3"
  },
  {
    label: "R",
    value: "r",
    lang: "r",
    versionIndex: "3"
  },
  {
    label: "Rhino JS",
    value: "rhino",
    lang: "javascript",
    versionIndex: "1"
  },
  {
    label: "Ruby",
    value: "ruby",
    lang: "ruby",
    versionIndex: "3"
  },
  {
    label: "Rust",
    value: "rust",
    lang: "rust",
    versionIndex: "3"
  },
  {
    label: "Scala",
    value: "scala",
    lang: "clike",
    versionIndex: "3"
  },
  {
    label: "Swift",
    value: "swift",
    lang: "swift",
    versionIndex: "3"
  }
];

const themeMenuOptions = [
  {
    label: "Gruvbox",
    value: "gruvbox-dark",
    type: "dark"
  },
  {
    label: "Dracula",
    value: "dracula",
    type: "dark"
  },
  {
    label: "Tomorrow Night",
    value: "tomorrow-night-eighties",
    type: "dark"
  },
  {
    label: "Monokai",
    value: "monokai",
    type: "dark"
  },
  {
    label: "Base-16 Dark",
    value: "base16-dark",
    type: "dark"
  },
  {
    label: "Material",
    value: "material",
    type: "dark"
  },
  {
    label: "Material Darker",
    value: "material-darker",
    type: "dark"
  },
  {
    label: "Palenight",
    value: "material-palenight",
    type: "dark"
  },
  {
    label: "Ayu Mirage",
    value: "ayu-mirage",
    type: "dark"
  },
  {
    label: "Bespin",
    value: "bespin",
    type: "dark"
  },
  {
    label: "Hopscotch",
    value: "hopscotch",
    type: "dark"
  },
  {
    label: "Icecoder",
    value: "icecoder",
    type: "dark"
  },
  {
    label: "Lucario",
    value: "lucario",
    type: "dark"
  },
  {
    label: "MBO",
    value: "mbo",
    type: "dark"
  },
  {
    label: "Oceanic Next",
    value: "oceanic-next",
    type: "dark"
  },
  {
    label: "Panda Syntax",
    value: "panda-syntax",
    type: "dark"
  },
  {
    label: "Railscasts",
    value: "railscasts",
    type: "dark"
  },
  {
    label: "Ruby Blue",
    value: "rubyblue",
    type: "dark"
  },
  {
    label: "Seti",
    value: "seti",
    type: "dark"
  },
  {
    label: "Shadow Fox",
    value: "shadowfox",
    type: "dark"
  },
  {
    label: "Moxer",
    value: "moxer",
    type: "dark"
  },
  {
    label: "The Matrix",
    value: "the-matrix",
    type: "dark"
  },
  {
    label: "Base-16 Light",
    value: "base16-light",
    type: "light"
  },
  {
    label: "Duotone Light",
    value: "duotone-light",
    type: "light"
  },
  {
    label: "Eclipse",
    value: "eclipse",
    type: "light"
  },
  {
    label: "Elegant",
    value: "elegant",
    type: "light"
  },
  {
    label: "Idea",
    value: "idea",
    type: "light"
  },
  {
    label: "MDN",
    value: "mdn-like",
    type: "light"
  },
  {
    label: "Neat",
    value: "neat",
    type: "light"
  },
  {
    label: "Neo",
    value: "neo",
    type: "light"
  },
  {
    label: "SSMS",
    value: "ssms",
    type: "light"
  },
  {
    label: "TTCN",
    value: "ttcn",
    type: "light"
  },
  {
    label: "XQ Light",
    value: "xq-light",
    type: "light"
  }
];

export { langMenuOptions, themeMenuOptions };
